module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticClass: "content-block-title"
  }, [_vm._v(_vm._s(_vm.plan.customerPlanName) + "成员信息")]), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  }, _vm._l((_vm.memberDetails), function(member) {
    return _c('ul', [_c('li', {
      staticClass: "item-content item-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/MemberDetails',
          query: {
            member: member,
            plan: _vm.plan
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('i', {
      staticClass: "icon icon-me",
      staticStyle: {
        "margin-right": "20px"
      }
    }), _vm._v(" "), (member.role === 1) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("储值联系人")]) : (member.role === 2) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("积分联系人")]) : (member.role === 3) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("管理联系人")]) : (member.role === 4) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("对账联系人")]) : (member.role === 5) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("普通成员")]) : _c('div', {
      staticClass: "item-title"
    }, [_vm._v("未知")]), _vm._v(" "), _c('div', {
      staticClass: "item-after",
      staticStyle: {
        "margin-left": "15px",
        "font-size": "smaller"
      }
    }, [_vm._v("\n                " + _vm._s(member.customerPlanMemberName) + "-" + _vm._s(member.customerPlanMemberNo) + "\n              ")])])])], 1)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7af603d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyVipPlan/VipPlanMemberDetails.vue
// module id = 1680
// module chunks = 8